export default "__VITE_ASSET__wGetpAOx__"